import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Chip from '@material-ui/core/Chip';
import IconButton from '@material-ui/core/IconButton';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Button from '../../../../components/button';
import DDItemCard from '../../components/dd-item-card';


class Step4BusinessContext extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchQuery: '',
      filterStatus: 'all',
      selectedItem: null, // Currently selected item for side panel
      expandedColumnsInPanel: {}, // Track expanded columns in side panel
      expandedColumnsInCards: {}, // Track expanded columns in card view
      expandedCategories: { tables: true, views: true, storedProcedures: true, functions: true, triggers: true }, // Track expanded categories
      autoSaveTimeout: null,
      ownerValue: [], // For business owner multi-select
      techOwnerValue: [], // For tech owner multi-select
      userListLoaded: false, // Track if business owner user list has been loaded
      techOwnerUserListLoaded: false // Track if tech owner user list has been loaded
    };
  }

  getAllItems = () => {
    const items = [];
    const { selectedItems, schemaMetadata } = this.props;
    
    // Safety checks
    if (!schemaMetadata || !selectedItems) {
      console.log('Step4: Missing schemaMetadata or selectedItems', { schemaMetadata, selectedItems });
      return items;
    }
    
    if (schemaMetadata) {
      ['tables', 'views', 'storedProcedures'].forEach(type => {
        const selected = selectedItems[type] || [];
        const allOfType = schemaMetadata[type] || [];
        allOfType.forEach(item => {
          if (selected.includes(item.id)) {
            items.push({ 
              ...item, 
              type,
              isParent: true,
              hasChildren: item.columnCount > 0 || (item.columns && item.columns.length > 0)
            });
          }
        });
      });
    }
    
    console.log('Step4: getAllItems returning', items.length, 'items');
    return items;
  }

  // Get columns for a specific table/view from the original API data
  getColumnsForItem = (item) => {
    const { fullSchemaData } = this.props;
    if (!fullSchemaData) return [];

    // Find the original item in fullSchemaData
    let sourceArray = [];
    if (item.type === 'tables') {
      sourceArray = fullSchemaData.tables || [];
    } else if (item.type === 'views') {
      sourceArray = fullSchemaData.views || [];
    }

    // Find matching item by name and schema
    const originalItem = sourceArray.find(t => 
      t.tableName === item.name || t.viewName === item.name
    );

    if (!originalItem || !originalItem.columns) return [];

    // Return columns with parent item ID for proper tracking
    return originalItem.columns.map((col, index) => ({
      id: `${item.id}_col_${index}`,
      parentId: item.id,
      name: col.name || col.COLUMN_NAME,
      dataType: col.dataType || col.DATA_TYPE,
      isNullable: col.isNullable || col.IS_NULLABLE,
      maxLength: col.maxLength || col.CHARACTER_MAXIMUM_LENGTH,
      defaultValue: col.defaultValue || col.COLUMN_DEFAULT,
      precision: col.precision || col.NUMERIC_PRECISION,
      scale: col.scale || col.NUMERIC_SCALE,
      isPrimaryKey: col.isPrimaryKey || col.IS_PRIMARY_KEY,
      isForeignKey: col.isForeignKey || col.IS_FOREIGN_KEY,
      isUnique: col.isUnique || col.IS_UNIQUE,
      isColumn: true,
      type: 'column'
    }));
  }

  // Get full item data with all available attributes
  getFullItemData = (item) => {
    const { fullSchemaData } = this.props;
    if (!fullSchemaData) return null;

    let sourceArray = [];
    if (item.type === 'tables') {
      sourceArray = fullSchemaData.tables || [];
    } else if (item.type === 'views') {
      sourceArray = fullSchemaData.views || [];
    } else if (item.type === 'storedProcedures') {
      sourceArray = fullSchemaData.storedProcedures || [];
    }

    const originalItem = sourceArray.find(t => 
      t.tableName === item.name || t.viewName === item.name || t.procedureName === item.name
    );

    return originalItem;
  }

  // Check if an attribute is selected
  isAttributeSelected = (category, attributeId) => {
    const { selectedAttributes } = this.props;
    if (!selectedAttributes || !selectedAttributes[category]) return false;
    return selectedAttributes[category].includes(attributeId);
  }

  // Render attribute value if selected
  renderAttributeIfSelected = (category, attributeId, label, value) => {
    if (!this.isAttributeSelected(category, attributeId)) return null;
    
    return (
      <div className="panel-attribute-row">
        <span className="panel-attribute-label">{label}</span>
        <span className="panel-attribute-value">{value || 'N/A'}</span>
      </div>
    );
  }

  // Render all selected attributes dynamically from data
  renderSelectedAttributes = (category, dataObject) => {
    const { selectedAttributes } = this.props;
    if (!selectedAttributes || !selectedAttributes[category]) return null;

    const selectedAttrIds = selectedAttributes[category];
    if (!selectedAttrIds || selectedAttrIds.length === 0) return null;

    const attributeRows = [];
    
    // For each selected attribute, try to find and render it
    selectedAttrIds.forEach(attrId => {
      // Extract the field name from the attribute ID (e.g., 'table_tableName' -> 'tableName')
      const fieldName = attrId.split('_').slice(1).join('_');
      
      if (dataObject && dataObject[fieldName] !== undefined) {
        // Format the label from the field name
        const label = fieldName
          .replace(/([A-Z])/g, ' $1')
          .replace(/^./, str => str.toUpperCase())
          .trim();
        
        attributeRows.push(
          <div key={attrId} className="panel-attribute-row">
            <span className="panel-attribute-label">{label}</span>
            <span className="panel-attribute-value">{dataObject[fieldName] || 'N/A'}</span>
          </div>
        );
      }
    });

    return attributeRows.length > 0 ? attributeRows : null;
  }

  filterItems = (items) => {
    const { searchQuery, filterStatus } = this.state;
    const { businessContextData } = this.props;
    
    let filtered = items;
    
    if (searchQuery) {
      filtered = filtered.filter(item => 
        item && item.name && item.name.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }
    
    if (filterStatus !== 'all') {
      filtered = filtered.filter(item => {
        const context = businessContextData[item.id];
        if (filterStatus === 'completed') {
          return context && context.businessContext && context.businessContext.trim();
        } else if (filterStatus === 'empty') {
          return !context || !context.businessContext || !context.businessContext.trim();
        }
        return true;
      });
    }
    
    return filtered;
  }

  handleFieldEdit = (itemId, value) => {
    const { businessContextData } = this.props;
    
    // Clear any pending auto-save
    if (this.state.autoSaveTimeout) {
      clearTimeout(this.state.autoSaveTimeout);
    }

    const updated = {
      ...businessContextData,
      [itemId]: {
        ...businessContextData[itemId],
        businessContext: value,
        isEdited: true
      }
    };

    this.props.onUpdate({ businessContextData: updated });
  }

  // Toggle a column-level flag (isPii / isAiEligible) during creation so the
  // PII/AI Sensitive flag is settable in Step 4, matching View/Edit (issue #612).
  handleColumnFlagToggle = (columnId, flag) => {
    const { businessContextData } = this.props;
    const current = businessContextData[columnId] || {};

    const updated = {
      ...businessContextData,
      [columnId]: {
        ...current,
        [flag]: !current[flag],
        isEdited: true
      }
    };

    this.props.onUpdate({ businessContextData: updated });
  }

  handleOwnerChange = (event, newValue) => {
    const { selectedItem } = this.state;
    const { businessContextData } = this.props;
    
    if (!selectedItem) return;
    
    // Store the full owner objects with userId, name, and email
    const ownerObjects = newValue.map(owner => {
      // Extract email from label format: "Name (email@example.com)"
      const emailMatch = owner.label.match(/\(([^)]+)\)/);
      const email = emailMatch ? emailMatch[1] : '';
      // Extract name (everything before the email)
      const name = owner.label.replace(/\s*\([^)]+\)\s*$/, '').trim();
      
      return {
        userId: owner.value,
        name: name,
        email: email
      };
    });
    
    this.setState({ ownerValue: newValue });

    const updated = {
      ...businessContextData,
      [selectedItem.id]: {
        ...businessContextData[selectedItem.id],
        owner: ownerObjects.length > 0 ? ownerObjects : null
      }
    };

    this.props.onUpdate({ businessContextData: updated });
  }

  handleOwnerDropdownOpen = () => {
    // Fetch user list only once when dropdown is first opened
    if (!this.state.userListLoaded && this.props.fetchUserList) {
      this.props.fetchUserList();
      this.setState({ userListLoaded: true });
    }
  }

  handleTechOwnerChange = (event, newValue) => {
    const { selectedItem } = this.state;
    const { businessContextData } = this.props;
    
    if (!selectedItem) return;
    
    // Store the full tech owner objects with userId, name, and email
    const techOwnerObjects = newValue.map(owner => {
      // Extract email from label format: "Name (email@example.com)"
      const emailMatch = owner.label.match(/\(([^)]+)\)/);
      const email = emailMatch ? emailMatch[1] : '';
      // Extract name (everything before the email)
      const name = owner.label.replace(/\s*\([^)]+\)\s*$/, '').trim();
      
      return {
        userId: owner.value,
        name: name,
        email: email
      };
    });
    
    this.setState({ techOwnerValue: newValue });
    
    const updated = {
      ...businessContextData,
      [selectedItem.id]: {
        ...businessContextData[selectedItem.id],
        techOwner: techOwnerObjects.length > 0 ? techOwnerObjects : null
      }
    };
    
    this.props.onUpdate({ businessContextData: updated });
  }

  handleTechOwnerDropdownOpen = () => {
    // Fetch tech owner user list only once when dropdown is first opened
    if (!this.state.techOwnerUserListLoaded && this.props.fetchTechOwnerList) {
      this.props.fetchTechOwnerList();
      this.setState({ techOwnerUserListLoaded: true });
    }
  }

  // Normalize an owner/user row into an Autocomplete option. Guards null rows
  // and coerces the id to a string so ids from the users API (numeric) match
  // stored owner ids (JSON, sometimes a string). Mirrors the #611 fix in
  // dd-details-view.js so the create flow can't hit the same id-mismatch class.
  toOwnerOption = (o) => {
    if (!o || typeof o !== 'object') return null;
    const id = o.userId != null ? o.userId : o.id;
    if (id == null) return null; // an id-less owner is unusable (and would collide on '')
    return {
      label: `${o.name || ''}${o.email ? ` (${o.email})` : ''}`.trim(),
      value: String(id)
    };
  }

  // Get owner options from props (loaded from API)
  getOwnerOptions = () => {
    const { userList } = this.props;
    if (!Array.isArray(userList)) return [];
    return userList.map(this.toOwnerOption).filter(Boolean);
  }

  // Get tech owner options from props (loaded from API)
  getTechOwnerOptions = () => {
    const { techOwnerList } = this.props;
    if (!Array.isArray(techOwnerList)) return [];
    return techOwnerList.map(this.toOwnerOption).filter(Boolean);
  }

  handleItemSelect = (item) => {
    const { businessContextData } = this.props;
    
    // Toggle: if clicking the same item, close the panel
    if (this.state.selectedItem && this.state.selectedItem.id === item.id) {
      this.setState({ selectedItem: null, ownerValue: [], techOwnerValue: [] });
    } else {
      // Get current owner values for this item
      const itemData = businessContextData[item.id] || {};
      const currentOwners = itemData.owner || [];
      const currentTechOwners = itemData.techOwner || [];
      
      // Map stored owner data to dropdown format (normalized ids, null-safe).
      const ownerValue = currentOwners.map(this.toOwnerOption).filter(Boolean);
      const techOwnerValue = currentTechOwners.map(this.toOwnerOption).filter(Boolean);
      
      this.setState({ 
        selectedItem: item,
        expandedColumnsInPanel: {}, // Reset expanded state when switching items
        ownerValue: ownerValue,
        techOwnerValue: techOwnerValue
      });
    }
  }

  handleClosePanel = () => {
    this.setState({ selectedItem: null });
  }

  toggleColumnInPanel = (columnId) => {
    this.setState(prevState => {
      const newExpanded = { ...prevState.expandedColumnsInPanel };
      if (newExpanded[columnId]) {
        delete newExpanded[columnId]; // Remove the key when collapsing
      } else {
        newExpanded[columnId] = true;
      }
      return { expandedColumnsInPanel: newExpanded };
    });
  }

  toggleColumnsInCard = (itemId) => {
    this.setState(prevState => ({
      expandedColumnsInCards: {
        ...prevState.expandedColumnsInCards,
        [itemId]: !prevState.expandedColumnsInCards[itemId]
      }
    }));
  }

  toggleCategory = (category) => {
    this.setState(prevState => ({
      expandedCategories: {
        ...prevState.expandedCategories,
        [category]: !prevState.expandedCategories[category]
      }
    }));
  }

  getCategoryLabel = (type) => {
    const labels = {
      tables: 'Tables',
      views: 'Views',
      storedProcedures: 'Stored Procedures',
      functions: 'Functions',
      triggers: 'Triggers'
    };
    return labels[type] || type;
  }

  toggleCategory = (category) => {
    this.setState(prevState => ({
      expandedCategories: {
        ...prevState.expandedCategories,
        [category]: !prevState.expandedCategories[category]
      }
    }));
  }

  getCategoryLabel = (type) => {
    const labels = {
      tables: 'Tables',
      views: 'Views',
      storedProcedures: 'Stored Procedures',
      functions: 'Functions',
      triggers: 'Triggers'
    };
    return labels[type] || type;
  }

  getStatusIcon = (item) => {
    const { businessContextData } = this.props;
    const context = businessContextData[item.id] || {};
    const hasItemContext = context.businessContext && context.businessContext.trim();
    
    // For items with columns, check if all columns are documented too
    if (item.hasChildren) {
      const columns = this.getColumnsForItem(item);
      if (columns.length > 0) {
        const allColumnsDocumented = columns.every(col => {
          const colContext = businessContextData[col.id] || {};
          return colContext.businessContext && colContext.businessContext.trim();
        });
        
        // Fully complete: item + all columns documented
        if (hasItemContext && allColumnsDocumented) {
          return (
            <span className="material-icons status-icon completed">
              check_circle
            </span>
          );
        }
        
        // Partially complete or incomplete
        return (
          <span className="material-icons status-icon incomplete">
            error_outline
          </span>
        );
      }
    }
    
    // For items without columns, just check the item context
    return (
      <span className={`material-icons status-icon ${hasItemContext ? 'completed' : 'incomplete'}`}>
        {hasItemContext ? 'check_circle' : 'error_outline'}
      </span>
    );
  }

  render() {
    const { businessContextData = {} } = this.props;
    const { searchQuery, filterStatus, selectedItem, expandedColumnsInPanel, expandedColumnsInCards } = this.state;

    const allItems = this.getAllItems();
    const filteredItems = this.filterItems(allItems);
    
    console.log('Step4 render:', { allItems: allItems.length, filteredItems: filteredItems.length, selectedItem });
    
    const completedCount = allItems.filter(item => {
      const ctx = businessContextData[item.id];
      return ctx && ctx.businessContext && ctx.businessContext.trim();
    }).length;

    return (
      <div className="step4-container-with-panel">
        {/* Main Content Area */}
        <div className="step4-main-content">
          <div className="step4-header">
            <TextField
              label="Search"
              placeholder="Search tables, columns, context..."
              value={searchQuery}
              onChange={(e) => this.setState({ searchQuery: e.target.value })}
              className="step4-search-field"
              InputProps={{
                startAdornment: <span className="material-icons search-icon">search</span>
              }}
              variant="standard"
              margin="normal"
              fullWidth
            />
            
            <FormControl variant="standard" className="step4-filter-control" margin="normal" fullWidth>
              <InputLabel>Filter by Status</InputLabel>
              <Select
                value={filterStatus}
                onChange={(e) => this.setState({ filterStatus: e.target.value })}
              >
                <MenuItem value="all">All Items</MenuItem>
                <MenuItem value="completed">Completed</MenuItem>
                <MenuItem value="empty">Empty</MenuItem>
              </Select>
            </FormControl>
          </div>

          <div className="completion-status">
            {completedCount} of {allItems.length} items documented
          </div>

          {/* Grouped Card Grid */}
          <div className="items-categories-container">
            {['tables', 'views', 'storedProcedures', 'functions', 'triggers'].map(category => {
              const categoryItems = filteredItems.filter(item => item.type === category);
              if (categoryItems.length === 0) return null;
              
              const isCategoryExpanded = this.state.expandedCategories[category];
              
              return (
                <div key={category} className="schema-group">
                  <div 
                    className="schema-group-header" 
                    onClick={() => this.toggleCategory(category)}
                  >
                    <span className="material-icons">
                      {isCategoryExpanded ? 'expand_more' : 'chevron_right'}
                    </span>
                    <h4>{this.getCategoryLabel(category)} ({categoryItems.length})</h4>
                  </div>
                  
                  {isCategoryExpanded && (
                    <div className="schema-items">
                      {categoryItems.map(item => {
                        const context = businessContextData[item.id] || {};
                        const columns = item.hasChildren ? this.getColumnsForItem(item) : [];
                        const isColumnsExpanded = expandedColumnsInCards[item.id];
                        const isSelected = selectedItem?.id === item.id;
                        
                        return (
                          <DDItemCard
                            key={item.id}
                            item={item}
                            isSelected={isSelected}
                            onClick={() => this.handleItemSelect(item)}
                            columns={columns}
                            businessContextData={businessContextData}
                            isColumnsExpanded={isColumnsExpanded}
                            onToggleColumns={() => this.toggleColumnsInCard(item.id)}
                            categoryLabel={item.type}
                          />
                        );
                      })}
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          {filteredItems.length === 0 && (
            <div className="empty-results">
              <span className="material-icons">search_off</span>
              <p>
                {allItems.length === 0 
                  ? 'No items selected in previous step. Please go back to Step 2 and select items.'
                  : 'No items match your search criteria'}
              </p>
            </div>
          )}
        </div>

        {/* Side Panel */}
        {selectedItem && (
          <div className="details-panel-container">
            <div className="details-panel-header">
              <div>
                <h3>{selectedItem.name || 'Not Available'}</h3>
                <div className="panel-item-type">
                  {selectedItem.type === 'storedProcedures' ? 'Stored Procedure' : selectedItem.type.replace(/([A-Z])/g, ' $1').trim()}
                </div>
              </div>
              <IconButton size="small" onClick={this.handleClosePanel}>
                <span className="material-icons">close</span>
              </IconButton>
            </div>
            
            <div className="details-panel-content">
              {/* Table/View/Stored Procedure Attributes */}
              {(() => {
                const fullItem = this.getFullItemData(selectedItem);
                const attributeCategory = selectedItem.type === 'tables' ? 'Table Attributes' : 
                                          selectedItem.type === 'views' ? 'View Attributes' : 
                                          selectedItem.type === 'storedProcedures' ? 'Stored Procedure Attributes' : null;
                
                if (!attributeCategory || !fullItem) return null;

                const hasSelectedAttributes = this.props.selectedAttributes && 
                                             this.props.selectedAttributes[attributeCategory] && 
                                             this.props.selectedAttributes[attributeCategory].length > 0;

                if (!hasSelectedAttributes) return null;

                return (
                  <div className="panel-section panel-attributes-container">
                    <div className="panel-attributes-list">
                      {this.renderSelectedAttributes(attributeCategory, fullItem)}
                    </div>
                  </div>
                );
              })()}

              {/* Table/View Level Context */}
              <div className="panel-section">
                <label className="panel-label">
                  Business Context
                </label>
                <TextField
                  value={businessContextData[selectedItem.id]?.businessContext || ''}
                  onChange={(e) => this.handleFieldEdit(selectedItem.id, e.target.value)}
                  multiline
                  rows={4}
                  fullWidth
                  placeholder="Enter business context for this item..."
                  helperText={`${(businessContextData[selectedItem.id]?.businessContext || '').length}/500 characters`}
                  inputProps={{ maxLength: 500, 'data-testid': 'dd-context-input', 'data-object-name': selectedItem.name }}
                  variant="outlined"
                />
              </div>

              {/* Owner Field */}
              <div className="panel-section">
                <Autocomplete
                  multiple
                  disableCloseOnSelect
                  filterSelectedOptions={true}
                  autoHighlight
                  options={this.getOwnerOptions()}
                  noOptionsText="No eligible users"
                  getOptionLabel={option => option.label}
                  getOptionSelected={(option, value) => option && value && String(option.value) === String(value.value)}
                  value={this.state.ownerValue}
                  onChange={this.handleOwnerChange}
                  onOpen={this.handleOwnerDropdownOpen}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip label={option.label} {...getTagProps({ index })} key={option.value} />
                    ))
                  }
                  renderInput={params => (
                    <TextField
                      {...params}
                      variant="standard"
                      label="Business Owner"
                      placeholder="Select business owners"
                      margin="normal"
                      fullWidth
                    />
                  )}
                />

                {/* Tech Owner Multi-Select */}
                <Autocomplete
                  multiple
                  disableCloseOnSelect
                  filterSelectedOptions={true}
                  autoHighlight
                  options={this.getTechOwnerOptions()}
                  noOptionsText="No eligible users"
                  getOptionLabel={option => option.label}
                  getOptionSelected={(option, value) => option && value && String(option.value) === String(value.value)}
                  value={this.state.techOwnerValue}
                  onChange={this.handleTechOwnerChange}
                  onOpen={this.handleTechOwnerDropdownOpen}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip label={option.label} {...getTagProps({ index })} key={option.value} />
                    ))
                  }
                  renderInput={params => (
                    <TextField
                      {...params}
                      variant="standard"
                      label="Tech Owner"
                      placeholder="Select tech owners"
                      margin="normal"
                      fullWidth
                    />
                  )}
                />
              </div>

              {/* Columns Section */}
              {selectedItem.hasChildren && (() => {
                const columns = this.getColumnsForItem(selectedItem);
                return columns.length > 0 && (
                  <div className="panel-columns-section">
                    <div className="panel-section-header">
                      <h4 className="panel-section-title">
                        Columns ({columns.length})
                      </h4>
                      <span
                        className="panel-expand-toggle"
                        onClick={() => {
                          const expandedCount = Object.keys(expandedColumnsInPanel).filter(key => expandedColumnsInPanel[key]).length;
                          if (expandedCount === columns.length) {
                            this.setState({ expandedColumnsInPanel: {} });
                          } else {
                            const allExpanded = {};
                            columns.forEach(col => allExpanded[col.id] = true);
                            this.setState({ expandedColumnsInPanel: allExpanded });
                          }
                        }}
                      >
                        {(() => {
                          const expandedCount = Object.keys(expandedColumnsInPanel).filter(key => expandedColumnsInPanel[key]).length;
                          return expandedCount === columns.length ? "Collapse All" : "Expand All";
                        })()}
                      </span>
                    </div>
                    
                    {columns.map(col => {
                      const colContext = businessContextData[col.id] || {};
                      const isExpanded = expandedColumnsInPanel[col.id];
                      
                      return (
                        <div 
                          key={col.id}
                          className={`panel-column-item ${isExpanded ? 'expanded' : ''}`}
                        >
                          <div
                            onClick={() => this.toggleColumnInPanel(col.id)}
                            className={`panel-column-header ${isExpanded ? 'expanded' : ''}`}
                          >
                            <span className="material-icons">
                              {isExpanded ? 'expand_more' : 'chevron_right'}
                            </span>
                            {this.getStatusIcon(col)}
                            <span className="panel-column-name">
                              {col.name}
                            </span>
                            {colContext.isPii && (
                              <span className="panel-pii-badge" data-testid={`pii-badge-${col.id}`}>PII</span>
                            )}
                            {colContext.isAiEligible && (
                              <span className="panel-ai-eligible-badge" data-testid={`ai-badge-${col.id}`}>AI Sensitive</span>
                            )}
                            <span className="panel-column-type">
                              {col.dataType}
                            </span>
                          </div>
                          
                          {isExpanded && (
                            <div className="panel-column-content">
                              {/* Column Attributes */}
                              {(() => {
                                const hasColumnAttrs = this.props.selectedAttributes && 
                                                      this.props.selectedAttributes['Column Attributes'] && 
                                                      this.props.selectedAttributes['Column Attributes'].length > 0;
                                
                                if (hasColumnAttrs) {
                                  return (
                                    <div className="panel-attributes-container">
                                      {this.renderSelectedAttributes('Column Attributes', col)}
                                    </div>
                                  );
                                }
                                return null;
                              })()}
                              
                              <label className="panel-label-small">
                                Column Business Context
                              </label>
                              <TextField
                                value={colContext.businessContext || ''}
                                onChange={(e) => this.handleFieldEdit(col.id, e.target.value)}
                                multiline
                                rows={3}
                                fullWidth
                                size="small"
                                placeholder="Describe this column's business purpose..."
                                helperText={`${(colContext.businessContext || '').length}/500`}
                                inputProps={{ maxLength: 500 }}
                                variant="outlined"
                              />
                              {/* Only table columns persist these flags on import;
                                  don't offer a toggle on view columns it can't save. */}
                              {selectedItem.type === 'tables' && (
                                <>
                                  <FormControlLabel
                                    control={
                                      <Switch
                                        checked={!!colContext.isPii}
                                        onChange={() => this.handleColumnFlagToggle(col.id, 'isPii')}
                                        color="secondary"
                                        inputProps={{ 'data-testid': `pii-toggle-${col.id}` }}
                                      />
                                    }
                                    label="PII"
                                    style={{ marginTop: 8 }}
                                  />
                                  <FormControlLabel
                                    control={
                                      <Switch
                                        checked={!!colContext.isAiEligible}
                                        onChange={() => this.handleColumnFlagToggle(col.id, 'isAiEligible')}
                                        color="primary"
                                        inputProps={{ 'data-testid': `ai-toggle-${col.id}` }}
                                      />
                                    }
                                    label="AI Sensitive"
                                    style={{ marginTop: 8 }}
                                  />
                                </>
                              )}
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                );
              })()}
            </div>

            <div className="details-panel-footer">
              <Button
                label="Close"
                className="btn btn-default"
                onClick={this.handleClosePanel}
                data-testid="dd-panel-close"
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default Step4BusinessContext;

